// extracted by mini-css-extract-plugin
export default {"list":"list--NyQxu","wrapper":"wrapper--aJ7iU"};